// Return true if any of the possible formats of tenant / user IDs match the provided ID
const isUser = (user, id) => {

	// wrapping the "id" in String just in case but it should never be the case
	return (
		String(user?.id) === String(id) ||
		String(user?._id) === String(id) ||
		String(user) === String(id)
	);
};

// __DEV__ is set in the web build; on the server fall back to NODE_ENV to allow local dev.
const isDevEnv = Boolean(process.env.__DEV__) || ['development', 'test'].includes(process.env.NODE_ENV);

export const isTenant = (tenant, id) => {

	// wrapping the "id" in String just in case but it should never be the case
	return (
		String(tenant?.id) === String(id) ||
		String(tenant?._id) === String(id) ||
		String(tenant) === String(id)
	);
};

export const AVC_MASTER_TENANT_ID = '65093f83361677d68c60932b';
export const AVC_MELBOURNE_ID = '5b2f3fcef3f027703264ff12';
export const AVC_SYDNEY_ID = '651c0d52671c2f8724f8d539';
export const AVC_BRISBANE_ID = '656db9d8ce87a1a85addfad2';
export const AVC_PERTH_ID = '67b6d90a2ac78985edf32dc1';

// AVC slave tenants (states) with display names
export const AVC_SLAVE_TENANTS = [
	{ id: AVC_MELBOURNE_ID, name: 'Melbourne', color: '#1769aa' },
	{ id: AVC_SYDNEY_ID, name: 'Sydney', color: '#c9512c' },
	{ id: AVC_BRISBANE_ID, name: 'Brisbane', color: '#1f8a5a' },
	{ id: AVC_PERTH_ID, name: 'Perth', color: '#b58105' },
];

// All AVC tenants (master + slaves)
export const AVC_TENANTS = [
	{ id: AVC_MASTER_TENANT_ID, name: 'AVC Master' },
	...AVC_SLAVE_TENANTS,
];

// Local testing tenant IDs
const AVC_LOCAL_TEST_IDS = [
	'6329bf03eb82acd3b6eb1801',
	'630f7b2797ee6943793021af',
	'6329bed9eb82acd3b6eb17a4',
];

export const isAVC = (tenant) => {
	return AVC_TENANTS.some(t => isTenant(tenant, t.id)) ||
		AVC_LOCAL_TEST_IDS.some(id => isTenant(tenant, id));
};

export const isMichael = (user) => {
	// helper used for Michael-specific easter eggs
	return isUser(user, '5c07561786dee61fe7f8ad3b') || isDevEnv;
};

export const isEamonn = (user) => {
	return isUser(user, '5c526be5b479b443f2787048') || isUser(user, '5d5dd830103b5f0c06483d4f') || isDevEnv;
};

export const ZBIGNIEW_USER_ID = '5d5dd830103b5f0c06483d4f';

export const isZbigniewAccount = (user) => {
	return isUser(user, ZBIGNIEW_USER_ID);
};

export const isZbigniew = (user) => {
	return isZbigniewAccount(user) || isDevEnv;
};

export const isBitconnect = (user) => {
	return user?.firstname === 'Carlos' && user?.lastname === 'Matos';
};
